import { render, staticRenderFns } from "./CollectionDisplay.vue?vue&type=template&id=49a90f28&scoped=true&"
import script from "./CollectionDisplay.vue?vue&type=script&lang=js&"
export * from "./CollectionDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDisplay.vue?vue&type=style&index=0&id=49a90f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a90f28",
  null
  
)

export default component.exports